module.exports = __webpack_public_path__ + "static/media/flutter.faf8f499.svg";